import { useSlots as _useSlots, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import '/node_modules/vue-select/dist/vue-select.css'

import { watch } from 'vue'
import VueSelect from 'vue-select'

import { ModelEvent } from '@/app/types/app/event'

import IconArrowDown from '@C/ui/icons/IconArrowDown.vue'

interface Props {
  autoSelectSingle?: boolean
  options: any[]
}

interface Emits {
  (event: ModelEvent.UpdateModelValue, value: any): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSelect',
  props: {
    autoSelectSingle: { type: Boolean },
    options: {}
  },
  setup(__props: any, { emit }) {

const props = __props;



const slots = _useSlots()

watch(
  () => props.options,
  (newOptions) => {
    if (props.autoSelectSingle && newOptions.length === 1) {
      emit(ModelEvent.UpdateModelValue, newOptions[0])
    }
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueSelect), _mergeProps({
    searchable: false,
    clearable: false,
    options: _ctx.options
  }, _ctx.$attrs), _createSlots({
    "open-indicator": _withCtx(({ attributes }) => [
      _createVNode(IconArrowDown, _normalizeProps(_guardReactiveProps(attributes as any)), null, 16)
    ]),
    _: 2
  }, [
    _renderList(_unref(slots), (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope as any)))
        ])
      }
    })
  ]), 1040, ["options"]))
}
}

})